import { useState, useEffect, useCallback } from 'react';
export const useInlineLinkingStreaming = (streamingInterval = 50, batchSize = 3) => {
	const [_, setBuffer] = useState<string[]>([]);
	const [inlineLinkingContent, setInlineLinkingContent] = useState<string>('');
	const [lastProcessedLength, setLastProcessedLength] = useState<number>(0);
	const [isBufferStreaming, setIsBufferStreaming] = useState<boolean>(false);

	const updateBuffer = useCallback((newContent: string) => {
		setIsBufferStreaming(true);
		setBuffer((prev) => [...prev, ...newContent.split('')]);
	}, []);

	useEffect(() => {
		const interval = setInterval(() => {
			setBuffer((prevBuffer) => {
				if (prevBuffer.length > 0) {
					const contentToProcess = prevBuffer.slice(0, batchSize).join('');
					let updatedBatchSize = batchSize;
					if (contentToProcess.includes('<')) {
						let closingBraceCount = 0;
						let i = 0;
						for (; i < prevBuffer.length; i++) {
							if (prevBuffer[i] === '>') {
								if (closingBraceCount === 1) {
									break;
								}
								closingBraceCount += 1;
							}
						}
						updatedBatchSize = i;
					}
					setInlineLinkingContent(
						(prevContent) => prevContent + prevBuffer.slice(0, updatedBatchSize).join(''),
					);
					return prevBuffer.slice(updatedBatchSize);
				}

				if (isBufferStreaming) {
					setIsBufferStreaming(false);
				}

				return prevBuffer;
			});
		}, streamingInterval);
		return () => clearInterval(interval);
	}, [batchSize, streamingInterval, isBufferStreaming]);

	return {
		inlineLinkingContent,
		updateBuffer,
		lastProcessedLength,
		setLastProcessedLength,
		isBufferStreaming,
	};
};
